const accessOnlineClass = {
    SCHEDULE_LIST: { name: 'Schedule', path: '/schedule-list' },
    ADD_SCHEDULE: { name: 'Add Schedule', path: '/create-schedule' },
    UPDATE_SCHEDULE: { name: 'Update Schedule', path: '/edit-schedule' },
    DELETE_SCHEDULE: { name: 'Delete Schedule', path: '/delete-schedule' },
}

export default accessOnlineClass;
